app.controller("StudentNewCardController", [
    "$scope", "$q", "StSubject", "Users", "AuthService", "ProgramService", "StaticData", "FreshModal", "ConfirmModal", "$stateParams", "$state", "toastr", "usSpinnerService",
    function ($scope, $q, StSubject, Users, AuthService, ProgramService, StaticData, FreshModal, ConfirmModal, $stateParams, $state, toastr, usSpinnerService) {
        $scope.subjects = [];
        $scope.totalItems = 0;
        $scope.itemsPerPage = 20;
        $scope.query = $stateParams.query;
        $scope.selections = [];
        $scope.student = null;
        $scope.enabled = true;
        $scope.allCredits = 0;
        $scope.programCredits = 240;

        $scope.changeLevel = function (student) {
            if (student)
                $state.go('.', { profile: student._id })
        };

        $scope.subjectStateClass = function (subject) {
            var stateClass;
            if (subject.state === 'passed') stateClass = 'passed-subject';
            if (subject.state === 'current') stateClass = 'current-subject';
            if (subject.state === 'failed') stateClass = 'failed-subject';
            return stateClass;
        };

        StaticData.getItemsByKey("levels").then(function (levels) {
            $scope.levels = [{ name: "საფეხური" }].concat(levels);
            $scope.levelsMap = _.keyBy($scope.levels, '_id');
        });

        StaticData.getItemsByKey("states").then(function (states) {
            $scope.states = states;
            $scope.statesMap = _.keyBy($scope.states, '_id');
        });

        AuthService.getProfiles().then(function (profiles) {
            $scope.profiles = _(profiles).filter({ type: 'student' }).value();
            var active = _(profiles).filter({ type: 'student', state: 'active' }).head();
            if (!active && $scope.profiles.length) {
                if ($scope.profiles.length == 1) {
                    $scope.student = $scope.profiles[0];
                    return $scope.changeLevel($scope.profiles[0]);
                } else {
                    $scope.student = _.find($scope.profiles, { _id: $stateParams.profile });
                    return $scope.changeLevel($scope.student);
                }
            }
            if ($stateParams.profile) $scope.student = _.find(profiles, { _id: $stateParams.profile });
            else if (active) $scope.student = active;
        });

        loadPage($stateParams.page, function () {
            $scope.currentPage = $stateParams.page;
        });

        $scope.toggle = function (val) {
            $scope.enabled = !$scope.enabled
        };

        // $scope.printStudentCard = function () {
        //     window.open('subject/export/' + $scope.student._id);
        // };

        $scope.openSubjectDetails = function (subject, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }

            FreshModal.open({
                controller: "StudentNewSubjectDetailsController",
                templateUrl: _pb + 'student-new/subject-details.html',
                resolve: {
                    subject: function () {
                        return subject;
                    }
                }
            }).then(function (result) {
            }, function (result) {
            });
        };

        function renderSelections(selections) {
            $scope.allCredits = 0;
            $scope.selections = selections;

            $scope.confessed = _(selections).filter('confessed').value();
            $scope.confessedCredits = _.sumBy($scope.confessed, 'credits');
            $scope.allCredits += $scope.confessedCredits;

            $scope.semesterSubjects = _($scope.selections).filter(function (s) {
                return !s.confessed;
            }).mapValues(function (s) {
                s.semester = s.semester || null;
                return s;
            }).groupBy('semester').mapValues(function (s) {
                return {
                    subjects: s, sum: _(s).filter(function (x) {
                        if (x.credits && x.state === 'passed') $scope.allCredits += x.credits;
                        return x.state === 'passed'
                    }).sumBy('credits'), average: _(s).filter(function (x) {
                        return x.state !== 'current';
                    }).meanBy('score')
                }
            }).value();

            $scope.keys = _.keys($scope.semesterSubjects).reverse();
        }

        function loadPage(page, cb) {
            cb = cb || function () {
            };
            usSpinnerService.spin("root");
            $q.all([StSubject.list({
                page: page,
                limit: $scope.itemsPerPage,
                student: $stateParams.profile
            }), StSubject.totals({ student: $stateParams.profile })]).then(function (data) {
                var selections = data[0];
                var totals = data[1];
                $scope.average = totals.average;
                $scope.gpa = totals.gpa;
                renderSelections(selections);
                usSpinnerService.stop("root");
                cb();
            });
        }

        $scope.generateClass = function (state) {
            if (state === 'active') return 'btn green';
            if (state === 'pause') return 'btn orange';
            if (state === 'candidate') return 'btn orange';
            if (state === 'abiturient') return 'btn orange';
            if (state === 'stop') return 'btn red';
            if (state === 'end') return 'btn red';
            else return 'btn grey'
        };
    }

]);
